module.exports = __webpack_public_path__ + "static/media/logo-비브리지@2x.b7dfae3b.png";